const UPDATE_RESOURCE = 'editResource/UPDATE_RESOURCE';
const UPDATE_LOADING_RESOURCE = 'editResource/UPDATE_LOADING_RESOURCE';

export default {
  UPDATE_RESOURCE,
  UPDATE_LOADING_RESOURCE
};
